import { Box, ScrollView, View } from "native-base";
import React from "react";
import { KeyboardAwareScrollView } from "react-native-keyboard-aware-scroll-view";

import { useViewport } from "@/contexts/ViewportContext";

import { ContainerProps } from "./types";

const ContainerMobile = ({ Header, children, overlapMaxHeight, ...props }: ContainerProps) => {
  const { height } = useViewport();

  return (
    <KeyboardAwareScrollView style={{ flex: 1, backgroundColor: "white" }}>
      <View maxHeight={overlapMaxHeight ? undefined : height} bgColor="white.50">
        <Box zIndex={1} bgColor="white.50" shadow="4">
          {Header}
        </Box>
        <ScrollView
          bgColor="white.50"
          showsVerticalScrollIndicator={false}
          showsHorizontalScrollIndicator={false}
          m={0}
          px="6"
          pt="4"
          pb="8"
          {...props}>
          {children}
        </ScrollView>
      </View>
    </KeyboardAwareScrollView>
  );
};

export default ContainerMobile;
